import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className="design-iconfont"
    >
      <path d="M12.7 9.1h-1.8V7.3c0-.495-.405-.9-.9-.9s-.9.405-.9.9v1.8H7.3c-.495 0-.9.405-.9.9s.405.9.9.9h1.8v1.8c0 .495.405.9.9.9s.9-.405.9-.9v-1.8h1.8c.495 0 .9-.405.9-.9s-.405-.9-.9-.9M10 17.2c-3.97 0-7.2-3.23-7.2-7.2S6.03 2.8 10 2.8s7.2 3.23 7.2 7.2-3.23 7.2-7.2 7.2M10 1c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9" />
    </svg>
  )
}
const CloseIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
CloseIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'rgb(var(--ow-primary-color))',
}
// 参数类型
CloseIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default CloseIcon
